import { NgModule } from '@angular/core';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedProviderModule } from '~app/shared/shared.module';
import { DateRangePickerComponent } from './date-range-picker.component';

/**
 * Date range picker. Based on https://ng-bootstrap.github.io/#/components/datepicker/examples#range-popup
 */
@NgModule({
  imports: [
    SharedProviderModule,
    NgbDatepickerModule,
  ],
  declarations: [DateRangePickerComponent],
  exports: [DateRangePickerComponent],
  providers: [],
})
export class DateRangePickerModule { }
